// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  LOGGED_IN_CATEGORY_PAGE_PAGE_SIZE,
  LOGGED_IN_FULL_WIDTH_CATEGORY_PAGE_PAGE_SIZE,
  LOGGED_IN_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE,
  LOGGED_IN_FULL_WIDTH_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE,
} from "@faire/deprecated-retailer-visitor-shared/app/_lib/templates/head/prefetches/__internal__/catNavPrefetches/consts";
import { useSettingEnableVisualNavUpgrade } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableVisualNavUpgrade";
import { useIsFullWidthCategory } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsFullWidthCategory";

/**
 * Inline banners would replace the space for product tiles. We get the accurate
 * number of replace tiles and then only request the remaining number of tiles.
 */
export const useRequestPageSize = (): number => {
  const isFullWidthCategory = useIsFullWidthCategory();
  const isVisualNavUpgrade = useSettingEnableVisualNavUpgrade();

  if (isFullWidthCategory && isVisualNavUpgrade) {
    return LOGGED_IN_FULL_WIDTH_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE;
  } else if (isFullWidthCategory && !isVisualNavUpgrade) {
    return LOGGED_IN_FULL_WIDTH_CATEGORY_PAGE_PAGE_SIZE;
  } else if (!isFullWidthCategory && isVisualNavUpgrade) {
    return LOGGED_IN_VISUAL_NAV_UPGRADE_CATEGORY_PAGE_PAGE_SIZE;
  }

  return LOGGED_IN_CATEGORY_PAGE_PAGE_SIZE;
};
